module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av364-010a2c042243fe331b1ae565dbd4e995.jpg";